export const getEStoreOrderList = state => {
    return state.list
}

export const getEStoreOrderDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/eStoreOrder/getters.js